import '../static/scss/index.scss' // 导入scss

import rui from '@/index.js'

window.Rui = rui
